import React from 'react';
import ArrSplitPanel from '../../../components/common/arr-split-panel/ArrSplitPanel';
import {Box, Typography} from '@mui/material';

const SplitPanelDemo: React.FC = () => {
  return (
    <Box height={'100vh'} width={'100vw'}>
      <ArrSplitPanel
        leftPanel={
          <Box>
            <Typography>This is Left Panel</Typography>
          </Box>
        }
        rightPanel={
          <Box>
            <Typography>This is Right Panel</Typography>
          </Box>
        }
      />
    </Box>
  );
};

export default SplitPanelDemo;
